import React from 'react';
import AppBarContext from './AppBarContext';
import AppBar from './AppBar';

export default function AppBarProvider(props)
{
  const [state, setState] = React.useState({});
  const callback = React.useCallback((state) => 
  {
    let cache;
    setState(last_state => {
      cache = last_state;
      return state;
    });

    return () => {
      setState(cache);
    }
  }, [setState]);

  return (
    <AppBarContext.Provider value={callback}>
      <AppBar {...state} />
      {props.children}
    </AppBarContext.Provider>
  );
}